// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--HEOPN","link":"a10a3f92e9--link--uq4Jj","text":"a10a3f92e9--text--u3Fty","arrow":"a10a3f92e9--arrow--tBPNZ"};